<template>
  <v-form v-if="!loading" class="ma-2" ref="form" v-model="valid" lazy-validation>
    <v-card>
      <v-system-bar>
        <span>Process / Verwerken</span>
      </v-system-bar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="8" sm="12" md="8">
              <v-card>
                <v-card-title>{{ identity.profile.name }} / {{ identity.profile.description }}</v-card-title>
                <v-simple-table>
                  <template v-slot:default>
                    <tbody>
                      <tr v-if="identity.organization">
                        <td class="subtitle-2">Organisatie / Organization</td>
                        <td>{{ identity.organization.name }}</td>
                      </tr>
                      <tr>
                        <td class="subtitle-2">Naam / Name</td>
                        <td>{{ identityPerson(identity).givenName + ' ' + (identityPerson(identity).surnamePrefix ? ' ' + identityPerson(identity).surnamePrefix : '') + ' ' + identityPerson(identity).surname }}</td>
                      </tr>
                      <tr>
                        <td class="subtitle-2">Startdatum / Start date</td>
                        <td>{{ $moment.utc(identity.startDate).local().format('dddd D MMM YYYY HH:mm') }}</td>
                      </tr>
                      <tr>
                        <td class="subtitle-2">Einddatum / End date</td>
                        <td v-if="identity.endDate">{{ $moment.utc(identity.endDate).local().format('dddd D MMM YYYY HH:mm') }}</td>
                      </tr>
                      <tr>
                        <td class="subtitle-2">Status</td>
                        <td>{{ statusIdToName(identity.status, true) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-col>
            <v-col cols="4" sm="12" md="4">
              <v-card :color="blockadeListStatusColor">
                <v-card-title>Blockade</v-card-title>
                <v-card-text>
                  <div v-if="identity.lookupResults && identity.lookupResults.length > 0 && identity.lookupResults[0].hasResults">
                    <div v-for="match in identity.lookupResults[0].matches" :key="match.key">
                      <div class="caption font-weight-medium" style="line-height:1.1rem;" v-html="showMatch(match.value)"></div>
                    </div>
                  </div>
                  <div class="caption font-weight-medium" v-if="identity.lookupResults && identity.lookupResults.length > 0 && identity.lookupResults[0].status > 0">Error processing lookup</div>
                  <div class="caption font-weight-medium" v-if="identity.lookupResults && identity.lookupResults.length > 0 && !identity.lookupResults[0].hasResults">Geen / None</div>
                  <div class="caption font-weight-medium" v-if="!identity.lookupResults || identity.lookupResults.length == 0">Onbekend / Unknown</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card color="#eeeeee">
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      v-for="asset in identity.profile.assetProfiles"
                      :key="asset.id"
                    >
                      <v-card xs12 class="mx-auto">
                        <v-card-title primary-title>
                          <div>{{asset.name}}</div>
                        </v-card-title>
                        <v-card-text v-if="asset.description">
                          <span class="grey--text subtitle-1">{{asset.name}}</span>
                        </v-card-text>
                        <v-container class="pt-0 mt-0" fluid>
                          <v-row>
                            <v-col cols="12">
                              <div v-for="field in asset.fields" :key="field.id">
                                <v-tooltip top v-if="field.type != 5 && field.type != 2 && field.type != 3">
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      v-on="field.description && on"
                                      v-model="field.value"
                                      v-bind:label="(field.name + ((field.type != 7 && field.type != 8 && field.isRequired) ? ' *': ''))"
                                      :required="field.type != 7 && field.type != 8 && field.isRequired"
                                      :rules="(field.type != 7 && field.type != 8 && field.isRequired) ? nameRules : []"
                                      autocomplete="off"
                                      :disabled="field.type == 7 || field.type == 8"
                                    ></v-text-field>
                                  </template>
                                  <span>{{field.description}}</span>
                                </v-tooltip>
                                <v-tooltip top v-if="field.type == 2 && identity.status == statusNameToId('Active')">
                                  <template v-slot:activator="{ on }">
                                    <v-switch
                                      v-on="field.description && on"
                                      v-model="field.value"
                                      :required="field.isRequired"
                                      v-bind:label="(field.name + (field.isRequired ? ' *': ''))"
                                    ></v-switch>
                                  </template>
                                </v-tooltip>
                                <v-tooltip top v-if="field.type == 5">
                                  <template v-slot:activator="{ on }">
                                    <v-autocomplete
                                      v-on="field.description && on"
                                      :items="field.items"
                                      item-text="name"
                                      item-value="value"
                                      :rules="autoRules"
                                      v-model="field.value"
                                      v-bind:label="(field.name + (field.isRequired ? ' *': ''))"
                                      autocomplete="off"
                                    ></v-autocomplete>
                                  </template>
                                  <span>{{field.description}}</span>
                                </v-tooltip>
                                <v-tooltip top v-if="field.type == 3" >
                                  <template v-slot:activator="{ onTooltip }">
                                    <v-menu
                                      v-model="datemenu"
                                      :close-on-content-click="false"
                                      transition="scale-transition"
                                      offset-y
                                      v-on="onTooltip"
                                      max-width="290px"
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          :value="computedStartDateFormatted"
                                          v-model="fieldsDates.find(x => x.id == field.id).dateFormatted"
                                          :required="field.value && field.value != ''"
                                          :rules="fieldsDates.find(x => x.id == field.id).date"
                                          v-bind:label="(field.name + (field.isRequired ? ' *': ''))"
                                          hint="DD-MM-YYYY"
                                          persistent-hint
                                          prepend-icon="event"
                                          @blur="date=fieldsDates.find(x => x.id == field.id).date = parseDate(fieldsDates.find(x => x.id == field.id).dateFormatted)"
                                          v-on="on"
                                          autocomplete="off"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        :locale="$moment.locale()"
                                        v-model="fieldsDates.find(x => x.id == field.id).date"
                                        no-title
                                        @input="fieldsDatePicker(field.id)"
                                      ></v-date-picker>
                                    </v-menu>
                                  </template>
                                  <span>{{field.discription}}</span>
                                </v-tooltip>
                              </div>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </v-col>
                    <v-col cols="12"> 
                      <div v-for="step in identity.profile.steps" :key="step.id">
                        <v-col cols="12" v-if="step.isValidationStep">
                          <v-card xs12 >
                            <v-card-title primary-title>
                              <div>{{step.name}}</div>
                            </v-card-title>
                            <v-card-text v-if="step.description">
                              <span class="grey--text subtitle-1">{{step.description}}</span>
                            </v-card-text>
                            <v-container class="pt-0 mt-0" fluid>
                              <v-row>
                                <v-col cols="12">
                                  <div class="mb-2" v-for="field in step.fields" :key="field.id">
                                    
                                      <v-tooltip
                                        top
                                        v-if="field.type != 37 && field.type != 21 && field.type != 1 && field.type != 2 && field.type != 3 && field.type != 5 && field.type != 38"
                                      >
                                        <template v-slot:activator="{ on }">
                                          <v-text-field
                                            v-on="field.description && on"
                                            v-model="field.value"
                                            v-bind:label="(field.name + (field.isRequired ? ' *': ''))"
                                            :required="field.isRequired"
                                            :rules="getRule(field.type, field.isRequired)"
                                            autocomplete="off"
                                          ></v-text-field>
                                        </template>
                                        <span>{{field.description}}</span>
                                      </v-tooltip>
                                      <v-tooltip top v-if="field.type == 1">
                                        <template v-slot:activator="{ on }">
                                          <v-textarea
                                            v-on="field.description && on"
                                            v-model="field.value"
                                            :required="field.isRequired"
                                            v-bind:label="(field.name + (field.isRequired ? ' *': ''))"
                                            autocomplete="off"
                                          ></v-textarea>
                                        </template>
                                        <span>{{field.description}}</span>
                                      </v-tooltip>
                                      <v-tooltip top v-if="field.type == 2">
                                        <template v-slot:activator="{ on }">
                                          <v-switch
                                            v-on="field.description && on"
                                            v-model="field.value"
                                            :required="field.isRequired"
                                            v-bind:label="(field.name + (field.isRequired ? ' *': ''))"
                                            @click="condition(field)"
                                            :disabled="field.isReadOnly"
                                          ></v-switch>
                                        </template>
                                        <span>{{field.description}}</span>
                                      </v-tooltip>

                                      <v-tooltip top v-if="field.type == 3 && fieldsDates">
                                        <template v-slot:activator="{ onTooltip }">
                                              <v-menu
                                                v-model="fieldsDates.find(f => f.id == field.id).datemenu"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                v-on="onTooltip"
                                                max-width="290px"
                                                min-width="290px"
                                              >
                                                <template v-slot:activator="{ on }">
                                                  <v-text-field
                                                    :value="computedStartDateFormatted"
                                                    v-model="fieldsDates.find(f => f.id == field.id).dateFormatted"
                                                    :required="field.value && field.value != ''"
                                                    :rules="getRule(field.type, (field.value && field.value != ''))"
                                                    v-bind:label="(field.name + (field.isRequired ? ' *': ''))"
                                                    prepend-icon="event"
                                                    @blur="fieldsDates.find(f => f.id == field.id).date=parseDate(fieldsDates.find(f => f.id == field.id).dateFormatted)"
                                                    v-on="on"
                                                    autocomplete="off"
                                                  ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                  :locale="$moment.locale()"
                                                  v-model="fieldsDates.find(f => f.id == field.id).date"
                                                  no-title
                                                  @input="fieldsDatePicker(field.id)"
                                                ></v-date-picker>
                                              </v-menu>
                                            </template>
                                        <span>{{field.description}}</span>
                                      </v-tooltip>

                                      <v-tooltip top v-if="field.type == 5">
                                        <template v-slot:activator="{ on }">
                                          <v-autocomplete
                                            v-on="field.description && on"
                                            :items="field.items"
                                            item-text="name"
                                            item-value="value"
                                            :rules="autoRules"
                                            v-model="field.value"
                                            v-bind:label="(field.name + (field.isRequired ? ' *': ''))"
                                          ></v-autocomplete>
                                        </template>
                                        <span>{{field.description}}</span>
                                      </v-tooltip>
                                    </div>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card>
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <template>
                        <v-textarea v-model="note" label="Opmerking / Note" auto-grow rows="1"></v-textarea>
                      </template>
                    </v-col>
                    <v-col cols="12">
                      <v-btn class="ma-2 float-right" @click="cancel">annuleer / cancel</v-btn>
                      <v-btn
                        class="ma-2"
                        color="success"
                        @click="submit(statusNameToId('Active'))"
                        :disabled="!valid"
                      >verder / proceed</v-btn>
                      <v-btn v-if="identity.status == statusNameToId('Announced')"
                        class="ma-2"
                        color="error"
                        @click="submit(statusNameToId('Revoked'))"
                      >afwijzen / decline</v-btn>
                      <span>{{submitStatus}}</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <br />
              <v-card>
                <v-list>
                  <v-list-group>
                    <template v-slot:activator>
                      <v-list-item-title>Details</v-list-item-title>
                    </template>
                    <v-list-item>
                      <v-list-item-content>
                        <v-card v-for="step in identity.profile.steps" :key="step.id">
                          <template v-if="!step.isValidationStep">
                          <v-card-title>{{ step.name }}</v-card-title>
                          <v-card-text>
                            <v-simple-table>
                              <template v-slot:default>
                                <tbody>
                                  <tr v-for="field in step.fields" :key="field.id" >
                                    <template v-if="(field.type == 3 || field.type == 21) && field.value != null">
                                      <td  width="50%">{{ field.name }}</td>
                                      <td>{{ $moment.utc(field.value).local().format("DD-MM-YYYY") }}</td>
                                    </template>
                                    <template v-else-if="field.type == 20">
                                      <td width="50%">{{ field.name }}:</td>
                                      <td>{{ sexesIdToName(field.value, true) }}</td>
                                    </template>
                                    <template v-else-if="field.type == 38 && field.value != null">
                                      <td width="50%">{{ getDocumentTypeNameById(field.name) }}</td>
                                      <td>{{ getDocumentDateById(field.name) }}</td>
                                    </template>
                                    <template v-else-if="field.type != 38">
                                      <td width="50%">{{ field.name }}:</td>
                                      <td>{{ showValue(field.value) }}</td>
                                    </template>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-card-text>
                          </template>
                        </v-card>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                  <v-list-group v-if="identity && identity.events">
                      <template v-slot:activator>
                        <v-list-item-title>Audit Trail</v-list-item-title>
                      </template>
                      <v-list-item>
                        <v-list-item-content>
                          <v-card>
                            <v-simple-table dense>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">Date/time</th>
                                    <th class="text-left">ModifiedBy</th>
                                    <th class="text-left">Action</th>
                                    <th class="text-left">Message</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="item in identity.events" :key="item.id">
                                    <td>{{ $moment.utc(item.created).local().format("DD-MM-YYYY HH:mm:ss") }}</td>
                                    <td>{{ (item.modifiedBy.surnamePrefix ? item.modifiedBy.surnamePrefix + " " : "") +  item.modifiedBy.surname }}</td>
                                    <td>{{ item.action }}</td>
                                    <td>{{ item.message }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-card>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
export default {
  props: ["identity"],
  data: () => ({
    loading: true,
    submitStatus: null,
    submitResult: null,
    organizationProfiles: [],
    organizations: [],
    startDate: new Date().toISOString().substr(0, 10),
    datemenu: false,
    date: null,
    dateFormatted: "",
    note: "",
    fieldsDates: null,
    valid: false,
    nameRules: [
      v => !!v || "This field is required",
      v => (v && v.length <= 100) || "100 characters maximum"
    ],
    autoRules: [
       v => !!v || "This field is required"
    ],
    documentTypes: [],
  }),
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    computedStartDateFormatted() {
      return this.startDate
        ? this.$moment.utc(this.startDate).format("ddd D MMM YYYY")
        : "";
    },
    blockadeListStatusColor() {
      let status = 'warning';
      if (this.identity.lookupResults && this.identity.lookupResults.length > 0) {
        if (this.identity.lookupResults[0].hasResults) {
          status = 'error'
        }
        else {
          if (this.identity.lookupResults[0].status == 0) {
            status = 'success'
          }
        }
      }
      return status;
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showMatch(val) {
      let matchstring = "<table>";
      var arr_match = val.split(';');
      arr_match.forEach(m => {
        var arr_kv = m.split('=');
        matchstring += "<tr><td style='vertical-align:top;padding-right:11px;'>" + arr_kv[0] + 
        "</td><td style='vertical-align:top;'>" + arr_kv[1] + "</td></tr>";
      });
      return matchstring + "</table>";
    },
    showValue(val) {
      if (val == "true") return "Ja / Yes";
      else if (val == "false") return "Nee / No";
      else return val;
    },
    getDocumentTypeNameById(id) {
      if (this.documentTypes.length == 0) {
        this.$http
        .get("api/documenttypes/")
        .then(request => {
          if (request.status == 200) {
            this.documentTypes = request.data;
            this.analyseProfile();
          }
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1500", e);
        });
      }
      if (this.documentTypes.length > 0){
        return this.documentTypes.find(x => x.id == id).name;
      }
      return '';
    },
    getDocumentDateById(id) {
      if (this.identity && this.identity.person && this.identity.person.documents) {
        var date = this.identity.person.documents.find(x => x.type.id == id).expirationDate;
        if (date != null)
          return this.$moment.utc(date).local().format("DD-MM-YYYY");
      }
      return '';
    },
    cancel() {
      this.$emit("done");
    },
    submit(status) {
      this.$parent.loading = true;
      if (status != this.statusNameToId('Revoked') && !this.$refs.form.validate()) {
        this.submitStatus = "ERROR";
        this.$parent.loading = false;
      } else {
        this.submitStatus = "POSTING";
        this.identity.profile.steps.forEach(step => {
          step.fields.forEach(stepField => {
            if (stepField.type == 3) {
                var fieldDate = this.fieldsDates.find(d => d.id == stepField.id).date;
                stepField.value = fieldDate ? fieldDate : '';
            }
          });
        });
        if (this.identity.status == this.statusNameToId('Active') && status == this.statusNameToId('Active')) status = this.statusNameToId('Expired');
        if (
          this.identity.id == null ||
          this.identity.id == "" ||
          this.identity.id == "00000000-0000-0000-0000-000000000000"
        )
          delete this.identity.id;

        this.identity.status = status;
        let indentityView = {
          identity: this.identity,
          assetProfiles: this.identity.profile.assetProfiles,
          note: this.note
        };
        this.$http
          .post("api/identities/", indentityView)
          .then(request => {
            if (request.status == 201) {
              this.submitStatus = "";
              this.$parent.processorResult = request.data;
            } else {
              this.submitStatus = "ERROR";
              this.$parent.loading = false;
            }
          })
          .catch(e => {
            this.$root.$children[0].$emit("display-error", "1501", e);
            this.submitStatus = "ERROR";
            this.$parent.loading = false;
          });
      }
    },
    back() {
      this.$emit("done");
    },
    getOrganizationProfiles() {
      this.$http
        .get("api/organizationprofiles/")
        .then(request => {
          this.organizationProfiles = request.data;
          this.loading = false;
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1502", e);
        });
    },
    getOrganizations() {
      this.$http
        .get("api/organizations/")
        .then(request => {
          this.organizations = request.data;
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1503", e);
        });
    },
    sexesIdToName(id, nl) {
      if (this.$root.$children[0]) {
        return this.$root.$children[0].getSexesName(id, nl);
      }
      else return "";
    },
    statusIdToName(id, nl) {
      if (this.$root.$children[0]) {
        return this.$root.$children[0].getIdentityStatusName(id, nl);
      }
      else return "";
    },
    statusNameToId(name) {
      if (this.$root.$children[0]) {
        return this.$root.$children[0].getIdentityStatusId(name);
      }
      else return "";
    },
    getRule(type, isRequired) {
      if (isRequired) return this.autoRules;
    },
    analyseProfile() {
      this.fieldsDates = [];
      this.identity.profile.steps.forEach(step => {
        step.fields.forEach(stepField => {
          if(stepField.type == 3) {
            var fieldDate = {id: stepField.id, datemenu: false, date: null, dateFormatted: ''};
            if (stepField.value != null && stepField.value != ""){
              fieldDate.date = stepField.value;
              fieldDate.dateFormatted = this.$moment.utc(stepField.value).local().format("DD-MM-YYYY");
            }
            this.fieldsDates.push(fieldDate);
          }
        });
      });
    },
    fieldsDatePicker(id) {
      this.fieldsDates.find(f => f.id == id).datemenu = false;
      this.fieldsDates.find(f => f.id == id).dateFormatted = this.formatDate(this.fieldsDates.find(f => f.id == id).date);
    },
    identityPerson(ident) {
      let person = { givenName:"", surnamePrefix:"", surname:"" };
      if (ident.sets && ident.sets[0].fields) {
        ident.sets[0].fields.forEach(f => {
          if (f.type == 10)
            person.givenName = f.value;
          else if (f.type == 13)
            person.surnamePrefix = f.value;
          else if (f.type == 14)
            person.surname = f.value;
        })
      }
      return person;
    }
  },
  mounted() {
    this.getOrganizationProfiles();
    this.getOrganizations();
    this.analyseProfile();
  }
};
</script>